import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryState, CategoryStore } from './category.store';
import { TabCategory } from 'src/app/models/tab_category.model';

@Injectable({ providedIn: 'root' })
export class CategoryQuery extends QueryEntity<CategoryState, TabCategory> {
  constructor(protected override store: CategoryStore) {
    super(store);
  }

  selectByFinalProductId(finalProductId: number): Observable<TabCategory[]> {
    return this.selectAll({
      filterBy: entity => entity.finalProductId === finalProductId
    });
  }

  // Method to get data by finalProductId (not as observable)
  getByFinalProductId(finalProductId: number): TabCategory[] {
    return this.getAll({
      filterBy: entity => entity.finalProductId === finalProductId
    });
  }
}
